module.exports = __webpack_public_path__ + "static/media/demerdelta.0c8f883c.png";